import { render, staticRenderFns } from "./mint.vue?vue&type=template&id=024b9adc&scoped=true&"
import script from "./mint.vue?vue&type=script&lang=js&"
export * from "./mint.vue?vue&type=script&lang=js&"
import style0 from "./mint.vue?vue&type=style&index=0&id=024b9adc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b9adc",
  null
  
)

export default component.exports